export const API_GET = 'GET';
export const API_POST = 'POST';
export const API_PUT = 'PUT';
export const API_DELETE = 'DELETE';
